module.exports = __webpack_public_path__ + "img/no.fecc6cc1.png";